import EncryptedStorage from 'react-native-encrypted-storage';
import { Platform } from 'react-native';

const KEY = 'vr_chat_list_view_prefs_v1';

const FILTERS = ['ALL', 'DIRECT', 'GROUP', 'CHANNEL'] as const;
const SORTS = ['RECENT', 'OLD', 'TITLE_ASC', 'TITLE_DESC'] as const;

export type ChatListViewFilter = (typeof FILTERS)[number];
export type ChatListViewSort = (typeof SORTS)[number];
type ChatListViewPrefs = { filter: ChatListViewFilter; sort: ChatListViewSort };

const DEFAULT: ChatListViewPrefs = { filter: 'ALL', sort: 'RECENT' };

function isWeb(): boolean {
  return Platform.OS === 'web';
}

function isFilter(v: unknown): v is ChatListViewFilter {
  return typeof v === 'string' && (FILTERS as readonly string[]).includes(v);
}

function isSort(v: unknown): v is ChatListViewSort {
  return typeof v === 'string' && (SORTS as readonly string[]).includes(v);
}

function normalize(raw: unknown): ChatListViewPrefs {
  if (!raw || typeof raw !== 'object') return DEFAULT;
  const o = raw as Record<string, unknown>;
  const filter = isFilter(o.filter) ? o.filter : DEFAULT.filter;
  const sort = isSort(o.sort) ? o.sort : DEFAULT.sort;
  return { filter, sort };
}

export async function readChatListViewPrefs(): Promise<ChatListViewPrefs> {
  try {
    let raw: string | null = null;
    if (isWeb()) {
      raw = globalThis.localStorage?.getItem(KEY) ?? null;
    } else {
      raw = await EncryptedStorage.getItem(KEY);
    }
    if (!raw) return DEFAULT;
    return normalize(JSON.parse(raw));
  } catch {
    return DEFAULT;
  }
}

export async function writeChatListViewPrefs(prefs: ChatListViewPrefs): Promise<void> {
  const payload = JSON.stringify(normalize(prefs));
  try {
    if (isWeb()) {
      globalThis.localStorage?.setItem(KEY, payload);
      return;
    }
    await EncryptedStorage.setItem(KEY, payload);
  } catch {
    /* ignore storage write errors */
  }
}
